export type LeaveInfo = {
  vin: string
  phone_number: string
  exiting_rule_id: number | null
  exiting_rule_name: string
  steps: []
  remark: string
  exit_category_id: number | null
  image_urls: string[]
  brand_id: number | null
  brand_name: string
}

// 包括当前页面 所有关于id和name的，不可修改
export type CommonSelectItem = {
  id: number
  name: string
}

export type ExitRuleItem = {
  rule_id: number
  rule_name: string
  text: string
  vin_required: boolean
  phone_number_required: boolean
}

export enum StepNoStatus {
  SPONSOR = 1, // 发起人
  AUDITOR // 审核人
}

export type ExitingRuleStepItem = {
  selEmployeeIds: number[]
  review_employee_choices: {
    employee_id: number,
    employee_name: string
  }[],
  selEmployee: {
    employee_id: number,
    employee_name: string
  }[]
  step_id: number,
  step_no: number,
  title: string,
}
